export const staffOnboardingEn = {
  staffOnboardingTitle: 'Link Google for faster sign-in',
  staffOnboardingIntro: 'Your administrator recommended linking Google on this device. You can skip and continue using your password.',
  staffOnboardingGmailHint: 'Use the same Gmail address that was registered for your account.',
  staffOnboardingLinkGoogle: 'Link Google',
  staffOnboardingSkip: 'Skip for now',
  staffOnboardingSettingsNote: 'You can link Google later in Settings → Account & security.',
  staffGoogleLinkOnboarding: 'Staff Google onboarding',
  staffGoogleLinkOnboardingDesc: 'Offer staff a one-time prompt to link Google after their first login.',
  registerOfferGoogleOnboarding: 'Offer Google link on first sign-in',
};

export const staffOnboardingEs = {
  staffOnboardingTitle: 'Vincula Google para entrar más rápido',
  staffOnboardingIntro: 'Tu administrador recomendó vincular Google en este dispositivo. Puedes omitir y seguir con tu contraseña.',
  staffOnboardingGmailHint: 'Usa la misma cuenta de Gmail registrada para tu usuario.',
  staffOnboardingLinkGoogle: 'Vincular Google',
  staffOnboardingSkip: 'Omitir por ahora',
  staffOnboardingSettingsNote: 'Puedes vincular Google después en Ajustes → Cuenta y seguridad.',
  staffGoogleLinkOnboarding: 'Onboarding Google para staff',
  staffGoogleLinkOnboardingDesc: 'Ofrece a staff un aviso único para vincular Google tras el primer acceso.',
  registerOfferGoogleOnboarding: 'Ofrecer vincular Google en el primer acceso',
};
